/* tslint:disable:no-console */

import { vsprintf } from 'sprintf-js';

import { currentMode } from 'core/util/Mode';
import { iDef } from './TypeUtils';

/**
 * @overview: Logger for outputting to the browser console system console when running
 * in dev mode. Only errors are displayed in production mode. Accepts message string and
 * typescript rest params. Parameter format for messages is standard sprintf: %s, %n, etc.
 *
 * @example Logger.warn("I'm sorry %s, I'm afraid I can't do that", "Dave");
 *
 * @author: jesposito
 */

export default class Logger {
	private static PREFIX: string = "";

	private static getMessage(message: string, args?: any[]): string {
		return Logger.PREFIX + vsprintf(message, args);
	}

	private static output(method: string, text: string) {
		if(text && iDef(window.console)) {
			if(window.console[method]) {
				window.console[method](text);
			} else {
				console.log(text);
			}
		}
	}

	public static throw(message: string, ...args: any[]) {
		throw Error(Logger.getMessage(message, args));
	}

	public static error(message: string, ...args: any[]) {
		const text: string = "ERROR: " + Logger.getMessage(message, args);
		Logger.output("error", text);
	}

	public static warn(message: string, ...args: any[]) {

		// Don't show warnings when not in production mode

		if (currentMode.isDev()) {
			const text: string = "WARN: " + Logger.getMessage(message, args);
			Logger.output("warn", text);
		}
	}

	public static debug(message: string, ...args: any[]) {

		// Don't show debug when not in production mode

		if (currentMode.isDev()) {
			const text: string = "DEBUG: " + Logger.getMessage(message, args);
			Logger.output("info", text);
		}
	}
}



// WEBPACK FOOTER //
// ./src/core/util/Logger.ts